export class AddressModel {
    line1?: any = null;
    formattedAddress?: any = null;
    town?: any = null;
    id?: any = null;
    postalCode?: any = null;
    line2?: any = null;

    constructor(address) {
        {
            if (address){
                this.line1 = address.line1 || null;
                this.formattedAddress = address.formattedAddress || null;
                this.town = address.town || null;
                this.postalCode = address.postalCode || null;
                this.line2 = address.line2 || null;
                this.id = address.id || null;
            }
        }
    }
}
